import { MODE_ALZADOS, MODE_FORCE_ALZADOS } from '@constants'
import { useAppStore } from '@store'
import { Material, Texture } from 'three'

/** Alzado con texturas activas (no plano/outline). */
export function isAlzadoTexturedView(): boolean {
  const { mode, isAlzadoOutlineMode } = useAppStore.getState()
  return (mode === MODE_ALZADOS || mode === MODE_FORCE_ALZADOS) && !isAlzadoOutlineMode
}

export function getAlzadoEffectiveRoughness(
  roughness: number | undefined,
  ignoreTextures: boolean,
): number {
  if (ignoreTextures) return 1
  const r = roughness ?? 1
  if (isAlzadoTexturedView() && r < 0.3) return Math.max(r, 0.5)
  return r
}

export function getAlzadoEffectiveMetalness(
  metalness: number | undefined,
  roughness: number | undefined,
  ignoreTextures: boolean,
): number {
  if (ignoreTextures) return 0
  const m = metalness ?? 0
  if (isAlzadoTexturedView() && (roughness ?? 1) < 0.3) return 0
  return m
}

export function getAlzadoEffectiveEnvMapIntensity(
  envMapIntensity: number | undefined,
  ignoreTextures: boolean,
): number {
  if (!isAlzadoTexturedView() || ignoreTextures) return envMapIntensity ?? 0
  return 0
}

/** Tras applyZoneMaterialFromZones / assignNodeTexture: evita espejo blanco en CRYSTAL (roughness≈0). */
export function tuneMaterialForAlzadoTexturedView(
  material: Material,
  zoneRoughness?: number,
): void {
  if (!isAlzadoTexturedView() || !material) return
  if (!('roughness' in material)) return

  const r = zoneRoughness ?? (material as { roughness?: number }).roughness ?? 1
  if (r < 0.3) {
    ;(material as { roughness: number }).roughness = Math.max(r, 0.5)
    if ('metalness' in material) {
      ;(material as { metalness: number }).metalness = 0
    }
  }
  if ('envMapIntensity' in material) {
    ;(material as { envMapIntensity: number }).envMapIntensity = 0
  }
  if ('envMap' in material) {
    ;(material as { envMap: Texture | null }).envMap = null
  }
  material.needsUpdate = true
}
